import * as Api from '@ViewModels';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { ITemplateCard } from '../../../../viewmodels/AppViewModels';
import { UserGroupPills } from '../../UserGroupPills';

interface IProps {
	card: ITemplateCard;
	userGroups: Api.IUserGroup[];
}

export const TemplateUserGroups = ({ card, userGroups }: IProps) => {
	const userSession = useUserSession();

	return card.creator?.id === userSession.user.id && card?.scope === Api.TemplateScope.Account ? (
		<UserGroupPills selectedUserGroupIds={card.userGroupIds} allUserGroups={userGroups} />
	) : null;
};
